import { useCallback, useMemo } from 'react';
import { useSnackbar } from 'notistack';
import { translateApiError } from './error-messages.js';

// Lucas 2026-05-11: errors e warnings precisam tempo extra (7s) pra operador
// ler. Success/info ficam com default da provider (3-5s típico).
const ERROR_WARNING_DURATION_MS = 7000;

export function useToast() {
  const { enqueueSnackbar } = useSnackbar();
  const notifySuccess = useCallback(
    (message: string) => enqueueSnackbar(message, { variant: 'success' }),
    [enqueueSnackbar]
  );
  const notifyError = useCallback(
    (message: string) => enqueueSnackbar(message, { variant: 'error', autoHideDuration: ERROR_WARNING_DURATION_MS }),
    [enqueueSnackbar]
  );
  const notifyWarning = useCallback(
    (message: string) => enqueueSnackbar(message, { variant: 'warning', autoHideDuration: ERROR_WARNING_DURATION_MS }),
    [enqueueSnackbar]
  );
  const notifyInfo = useCallback(
    (message: string) => enqueueSnackbar(message, { variant: 'info' }),
    [enqueueSnackbar]
  );
  return useMemo(
    () => ({ notifySuccess, notifyError, notifyWarning, notifyInfo }),
    [notifySuccess, notifyError, notifyWarning, notifyInfo]
  );
}

export function getErrorMessage(error: unknown, fallback?: string): string {
  return translateApiError(error, fallback);
}
